<script setup lang="ts">
const { t } = useI18n();

const emit = defineEmits<{
  (e: 'verify-click'): void;
}>();
</script>

<template>
  <div
    class="mb-4 flex flex-wrap items-center gap-3 rounded-[12px] border border-success/30 bg-success/10 px-[18px] py-3"
  >
    <span
      class="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white text-success"
      aria-hidden="true"
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 3l8 3v6c0 5-3.4 8.5-8 9.5C7.4 20.5 4 17 4 12V6l8-3z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    </span>
    <i18n-t
      keypath="property.access.registeredVerifyChip.description"
      tag="span"
      class="min-w-0 flex-1 text-[13.5px] text-black-80"
    >
      <template #bold
        ><b class="font-bold text-black-100">{{
          t('property.access.registeredVerifyChip.descriptionBold')
        }}</b></template
      >
    </i18n-t>
    <button
      type="button"
      class="shrink-0 rounded-lg border border-success/40 bg-white px-3 py-1.5 text-[13px] font-bold text-success transition-colors hover:bg-success/10"
      @click="emit('verify-click')"
    >
      <span
        >{{ t('property.access.shared.verifyThirtySec') }}
        <span
          class="inline-block rtl:-scale-x-100"
          aria-hidden="true"
          >→</span
        ></span
      >
    </button>
  </div>
</template>
